export default __webpack_public_path__ + "static/media/ehmal.124fefdd.jpg";